import React, { Component } from 'react'
import style from './style'
import { Divider, GridList, Grid, withStyles, Typography } from '@material-ui/core'
import size from 'lodash/size'
import inRange from 'lodash/inRange'


const COLUMNS = 5
class CustomGridList extends Component {

    render() {
        const {logos, title, classes } = this.props
        return  <React.Fragment>
                    <Typography variant="caption">{title}</Typography>
                    <GridList style={{paddingBottom: 10}} cellHeight={40} cols={COLUMNS}>                        
                    {
                        logos.map((logo, ix) =>
                            <Grid className={classes.row} key={ix} cols={1}>
                                <img alt="" src={`${window.env.ASSETS_URL}/images/cards/${logo}.svg`} className={classes.card} />
                                {  (inRange(ix, size(logos) - 1) && (ix + 1) % 5 !== 0) && 
                                    <Divider data-testid="divider" className={classes.divider}/>
                                }
                            </Grid>
                        )
                    }
                    </GridList>
                </React.Fragment>
    }

}

export default withStyles(style)(CustomGridList)